var styles = {"option":"styles_option__ntyFM","active":"styles_active__hCSKv","selectedItem":"styles_selected-item__-fs0T"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
